import React, {useContext, useEffect, useState} from 'react';
import {AppContext} from '../context/AppContext';

const OfflineBanner: React.FC = () => {
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('OfflineBanner must be used within AppContextProvider');
  }

  const {i18n} = context;

  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div
      id="offline-banner"
      className={`offline ${isOnline ? 'hidden' : ''}`}
    >
      {i18n.t('offline')}
    </div>
  );
};

export default OfflineBanner;